module.exports = __webpack_public_path__ + "img/1_m.b232c1bf.jpg";